<template>
  <div>
    <section v-if="question">
      <WizardStepAddTeamMember
        v-if="question.type === 'invite_team_member'"
        @next="nextStep"
        @goto="goTo"
      />
      <WizardStepAddCaterer
        v-else-if="question.type === 'invite_caterer'"
        @next="nextStep"
        @goto="goTo"
      />
      <WizardStepCatererLocation
        v-else-if="question.type === 'caterers_by_zip'"
        @next="nextStep"
        @goto="goTo"
      />
      <WizardStepEventPlannerLocation
        v-else-if="question.type === 'event_planner_by_zip'"
        @next="nextStep"
        @goto="goTo"
      />
      <WizardFinalStep
        v-else-if="question.type === 'final_step'"
      />
      <WizardStepAddSupplier
        v-else-if="question.type === 'invite_supplier'"
        @next="nextStep"
        @goto="goTo"
      />
      <WizardCSRForm
        v-else-if="question.type === 'csrform'"
        @next="nextStep"
        @goto="goTo"
        @back="$emit('back')"
      />


      <div v-else>
        <h6 class="opacity-50 text-xs uppercase font-semibold mb-2 text-center">
          {{ question.title}}
        </h6>
        <h1 class="sm:mb-8 text-center text-2xl lg:text-3xl font-semibold">
          {{ question.question }}
        </h1>


        <section class="grid grid-cols-12 gap-6 max-w-6xl mx-auto">
          
          <div v-if="isFirstStep" class="col-span-12 md:col-span-7">
            <div class="flex justify-center flex-col-reverse sm:flex-row">
              <button
                class="btn btn-primary font-semibold rounded px-10 w-full sm:w-40"
                @click="submitAnswer"
                :disabled="!currentAnswer"
              >
                <span v-if="!loading">Next</span>
                <Spinner class="mx-auto" v-if="loading" />
              </button>
            </div>
          </div>

          <div class="col-span-12 md:col-span-7">

            <StepAnswers :key="`current-answer-${question.id}`" :answers="question.answers" v-model="currentAnswer" />

            <div class="flex justify-center flex-col-reverse sm:flex-row mt-10">
              <button
                v-if="!isFirstStep"
                class="btn btn-secondary font-semibold rounded px-10 mr-0 sm:mr-4 mt-3 sm:mt-0 w-full sm:w-40 sm:flex-none"
                @click="$emit('back')"
              >
                Back
              </button>
              <button
                class="btn btn-primary font-semibold rounded px-10 w-full sm:w-40"
                @click="submitAnswer"
                :disabled="!currentAnswer"
              >
                <span v-if="!loading">Next</span>
                <Spinner class="mx-auto" v-if="loading" />
              </button>
            </div>
          </div>
          <div class="col-span-12 md:col-span-5">
            <div class="bg-white rounded-lg shadow-card p-8 sm:p-12">
              <h1 class="mb-3 font-semibold text-lg">
                Helper Info Box
              </h1>
              <p v-if="question.help">{{ question.help }}</p>
              <p v-else>
                A BOX can be a lot of things. For example, with an important meeting It may refer to an actual Boxed Lunch.
                For a promotional campaign or event, a box can be a Super Personalized Gift Box, filled with the exact items
                that each individual wanted. For an Onboarding System, a box is the collection of items that a new employee
                needs to get started and in the case of a family gathering or personal gathering, it may not even be a box
                at
                all. It can just be a way to gauge what each attendee plans to eat so you don’t end up being wasteful and
                throwing food in the trash.
                <br /><br />
                And that’s what a box is - a super personalized way to make sure everyone gets what they want and need while
                cutting down on waste.
              </p>
            </div>
          </div>
        </section>
      </div>
      </section>
  </div>
</template>

<script>
import Apiv1 from "@/api/api_v1.0.js";
import Api from "@/api";
import StepAnswers from "@/views/segmentation/steps/StepAnswers";
import Spinner from "@/components/common/Spinner"
import { mapGetters } from 'vuex'
import WizardStepAddTeamMember from "@/views/segmentation/steps/WizardStepAddTeamMember";
import WizardStepAddCaterer from "@/views/segmentation/steps/WizardStepAddCaterer";
import WizardStepCatererLocation from "@/views/segmentation/steps/WizardStepCatererLocation";
import WizardStepEventPlannerLocation from "@/views/segmentation/steps/WizardStepEventPlannerLocation";
import WizardStepAddSupplier from "@/views/segmentation/steps/WizardStepAddSupplier";
import WizardFinalStep from "@/views/segmentation/steps/WizardFinalStep";
import WizardCSRForm from "@/views/segmentation/steps/WizardCSRForm";

export default {
  name: "SegmentationStep",

  components: {
    Spinner,
    StepAnswers,
    WizardStepAddTeamMember,
    WizardStepAddCaterer,
    WizardStepCatererLocation,
    WizardStepEventPlannerLocation,
    WizardStepAddSupplier,
    WizardFinalStep,
    WizardCSRForm,
  },

  async created() {

    const timer = setInterval(() => {
      if(this.question) {
        clearInterval(timer);
        this.init();
      }
    })

    
  },

  data() {
    return {
      loading: false,
      currentAnswer: null
    }
  },

  computed: {
    ...mapGetters(['segmentationOrder', 'segmentationQuestions']),

    currentAnswerData() {
      return this.currentAnswer ? this.question.answers.find(answer => answer.id === this.currentAnswer) : null;
    },

    isFirstStep() {
      return this.$route.params.id == 1;
    },

    orderUuid() {
      return this.segmentationOrder?.uuid;
    },

    editOrderRoute() {
      return `/orders/${this.orderUuid}/edit/details`;
    },

    question() {
      return this.segmentationQuestions.find(question => question.id == this.$route.params.id);
    }
  },

  methods: {
    init() {
      // if final step - redirect to edit order
      if(this.question.type === 'final_step') {
        this.$store.commit('setCurrentEditingOrder', this.segmentationOrder);
        this.$router.push(this.editOrderRoute);
        return;
      }

      // load current answer from vuex
      if(this.segmentationOrder.uuid && this.segmentationOrder.segmentations[this.question.id]) {
        this.currentAnswer = this.segmentationOrder.segmentations[this.question.id];
      }
    },
    
    async submitAnswer() {
      this.loading = true;

      if (this.segmentationOrder.uuid) {
        await Api.updateOrderWith(this.segmentationOrder.uuid, {
          segmentation: {
            [this.question.id]: this.currentAnswer
          }
        })

        this.$store.commit('setSegmentationOrder', {
          ...this.segmentationOrder,
          segmentations: {
            ...this.segmentationOrder.segmentations,
            [this.question.id]: this.currentAnswer
          }
        })

        this.loading = false;
        this.nextStep();
      } else {
        const response = await Api.createOrderWith({
          process: 1,
          segmentation: {
            [this.question.id]: this.currentAnswer
          }
        });

        const order = response.data;

        this.$store.commit('setSegmentationOrder', {
          ...order,
          process: 1,
          segmentations: {
            [this.question.id]: this.currentAnswer
          }
        })

        this.loading = false;
        this.nextStep();
      }
    },

    nextStep() {
      try {
        this.$router.push({
          name: 'segmentation-step',
          params: {
            id: this.question.next_question_id ? this.question.next_question_id : this.currentAnswerData.next_question_id
          },
          query: this.$route.query
        });
      } catch (err) {
        console.error('Question or answer doesnt have next question id', err)
      }
    },

    goTo(data) {
      const q = this.getQuestionByType(data.type);

      try {
        this.$router.push({
            name: 'segmentation-step',
            params: {
              id: q.id
            },
            query: this.$route.query
        });
      } catch (err) {
        console.error('undefined question with type:', data)
      }

    },

    getQuestionByType(type) {
      return this.segmentationQuestions.find(question => question.type == type);
    }
  }
}
</script>

<style scoped>

</style>
